module.exports = __webpack_public_path__ + "zvetseni-rtu-permalip_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-rtu-permalip_5_before.jpg
// module id = 1382
// module chunks = 0